module.exports = __webpack_public_path__ + "4e87a9e61d079703750fb8af6acd56c7.png";